import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ErrorPage401 } from "./ErrorPage401";
import { ErrorPage404 } from "./ErrorPage404";

export default function ErrorsPage() {
  return (
    <Switch>
      <Redirect from="/error" exact={true} to="/error/404" />
      <Route path="/logout" component={ErrorPage401} />
      <Route path="/error/404" component={ErrorPage404} />
    </Switch>
  );
}
